export default "__VITE_ASSET__CBAaiOw5__"